import { render } from "./ManagementView.vue?vue&type=template&id=ddf7e876&scoped=true"
import script from "./ManagementView.vue?vue&type=script&lang=js"
export * from "./ManagementView.vue?vue&type=script&lang=js"

import "./ManagementView.vue?vue&type=style&index=0&id=ddf7e876&scoped=true&lang=css"

import exportComponent from "../../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf7e876"]])

export default __exports__